import { TemplateId } from "../../globalTypes";
import { RowKey } from "../table/types";

export const fetchAllTemplatesMetadata = () => `api/Templates/Metadata`;

export const fetchTemplateMetadata = (
  templateId: TemplateId,
  rowKey?: RowKey
): string => {
  const urlBase = `api/Templates/Metadata/${templateId}`;
  if (rowKey) {
    return `${urlBase}?rowKey=${rowKey}`;
  }

  return urlBase;
};

export const fetchFunctionTemplatesForTemplateId = (templateId: TemplateId) =>
  `api/Templates/GetFunctionTemplates/${templateId}`;

export const fetchTemplateMetadataBulk = (ids: (number | string)[]) => {
  let url = `api/Templates/MetadataBulk`;
  if (ids.length > 0) {
    let i = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const id of ids) {
      const c = i === 0 ? "?" : "&";
      url += `${c}ids=${id}`;
      i += 1;
    }
  }
  return url;
};

export const copyTemplate = () => `api/Templates/Copy`;

export const getTemplateTableRow = (templateId: TemplateId) =>
  `api/Templates/GetTableRow/${templateId}`;

export const deleteTemplate = (templateId: TemplateId) =>
  `api/Templates/${templateId}`;

export const getAdministrationTemplateTable = (
  pageNum: number,
  maxPageRowCount: number,
  orderSearch: string,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) => {
  let url = `api/Templates/GetTable?pageNum=${pageNum}&maxPageRowCount=${maxPageRowCount}&orderSearch=${orderSearch}`;
  if (fulltextKeyword) url += `&fulltextKeyword=${fulltextKeyword}`;
  hiddenColumns.forEach((column) => {
    url += `&ignoreColumns=${column}`;
  });
  return url;
};

export const updateTemplate = (keyValue: number | string) =>
  `api/Templates/${keyValue}`;

export const postTemplate = () => "api/Templates";

export const importHegTemplate = () =>
  "api/Templates/ImportHegOverviewTemplate";

export const getRowsPerPageForTemplateId = (templateId: TemplateId) =>
  `/api/UserSettings/RowPageCount?templateId=${templateId}`;

export const setRowsPerPageForTemplateId = () =>
  `/api/UserSettings/RowPageCount`;

export const fetchTemplateVersionTable = () =>
  `/api/Templates/Version/GetTemplateVersionsTable`;

export const getTemplateVersionTableRow = (rowKey: RowKey) =>
  `/api/Templates/Version/Row/${rowKey}`;

export const updateTemplateVersionTableRow = (rowKey: RowKey) =>
  `/api/Templates/Version/Row/${rowKey}`;

export const templatesSelect = () => "/api/Templates/Selection";

// ------------- TEMPLATE IMPORT/EXPORT ---------------

export const templateExportWithId = (templateId: number) =>
  `/api/TemplateExports/${templateId}`;

export const templateImports = () => "/api/TemplateImports";

export const templateImportsWithId = (templateImportId: number) =>
  `${templateImports()}/${templateImportId}`;

export const templateImportDetails = () => "/api/TemplateImportDetails";

export const templateImportDetailsWithId = (detailId: number) =>
  `${templateImportDetails()}/${detailId}`;

export const runTemplateImports = () => "/api/RunTemplateImports";
